"use client";

import { analytics } from "@repo/analytics/posthog/client";
import { useEffect } from "react";

export function SessionRecording() {
	useEffect(() => {
		if (typeof window !== "undefined" && analytics) {
			analytics.startSessionRecording();
		}
	}, []);

	return null;
}
